import React, { FunctionComponent } from 'react'

interface VimeoProps {
  id: string
  title: string
}

const Vimeo: FunctionComponent<VimeoProps> = ({ id, title }) => (
  <iframe
    allow="autoplay; fullscreen"
    allowFullScreen
    frameBorder="0"
    height="360"
    src={`https://player.youku.com/embed/${id}`}
    title={title}
    width="640"
  />
)

export default Vimeo
